module.exports = __webpack_public_path__ + "users-group.50c4d0e59b44d8bec3a40e6bcb38ab4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/users-group.svg
// module id = 1154
// module chunks = 0